import type { ClientArgs, ClientInferResponseBody } from '@ts-rest/core';
import type { UseQueryOptions } from '@ts-rest/react-query/v5';

import type { IndustriesContract } from '@packages/contracts';

import { INDUSTRY_QUERY_KEY } from '../query-keys';

type IndustryChildrenRoute = typeof IndustriesContract['listChildrenById'];
type IndustryChildrenResponse = ClientInferResponseBody<IndustryChildrenRoute, 200>['result']['industries'];
export type IndustryChildrenQueryOptions = UseQueryOptions<
	IndustryChildrenRoute,
	ClientArgs,
	IndustryChildrenResponse
>;

export const createIndustryChildrenQueryOptions = (industryId?: string): IndustryChildrenQueryOptions => ({
	queryData: { params: { industryId: industryId ?? '' } },
	queryKey:  INDUSTRY_QUERY_KEY.children(industryId ?? 'all'),

	retry: (failureCount: number, error) => {
		if ('statusCode' in error && (error.statusCode === 404 || error.statusCode === 400)) return false;

		return failureCount < 3;
	},
	select: response => response.body.result.industries,
});
